export { default } from './ZccInstallations';
export { default as reducer } from './ZccInstallations.ducks';
export { default as sagas } from './ZccInstallations.sagas';

import * as actions from './ZccInstallations.ducks';

export { actions };
